module.exports = __webpack_public_path__ + "assets/img/btn-detail-47cee6ed.png";